// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ShopRouteImport } from './routes/shop'
import { Route as ShippingReturnsRouteImport } from './routes/shipping-returns'
import { Route as ReviewsRouteImport } from './routes/reviews'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as NightGolfRouteImport } from './routes/night-golf'
import { Route as MiniGolfRouteImport } from './routes/mini-golf'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as GiftsRouteImport } from './routes/gifts'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as EventsRouteImport } from './routes/events'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CartRouteImport } from './routes/cart'
import { Route as BundlesRouteImport } from './routes/bundles'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AmazonRouteImport } from './routes/amazon'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProductsSlugRouteImport } from './routes/products.$slug'
import { Route as LpSlugRouteImport } from './routes/lp.$slug'
import { Route as LegalTermsRouteImport } from './routes/legal.terms'
import { Route as LegalPrivacyRouteImport } from './routes/legal.privacy'
import { Route as LegalCookiesRouteImport } from './routes/legal.cookies'
import { Route as LegalAccessibilityRouteImport } from './routes/legal.accessibility'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'

const ShopRoute = ShopRouteImport.update({
            id: '/shop',path: '/shop',getParentRoute: () => rootRouteImport
          })
const ShippingReturnsRoute = ShippingReturnsRouteImport.update({
            id: '/shipping-returns',path: '/shipping-returns',getParentRoute: () => rootRouteImport
          })
const ReviewsRoute = ReviewsRouteImport.update({
            id: '/reviews',path: '/reviews',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const NightGolfRoute = NightGolfRouteImport.update({
            id: '/night-golf',path: '/night-golf',getParentRoute: () => rootRouteImport
          })
const MiniGolfRoute = MiniGolfRouteImport.update({
            id: '/mini-golf',path: '/mini-golf',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const GiftsRoute = GiftsRouteImport.update({
            id: '/gifts',path: '/gifts',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const EventsRoute = EventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CartRoute = CartRouteImport.update({
            id: '/cart',path: '/cart',getParentRoute: () => rootRouteImport
          })
const BundlesRoute = BundlesRouteImport.update({
            id: '/bundles',path: '/bundles',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AmazonRoute = AmazonRouteImport.update({
            id: '/amazon',path: '/amazon',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProductsSlugRoute = ProductsSlugRouteImport.update({
            id: '/products/$slug',path: '/products/$slug',getParentRoute: () => rootRouteImport
          })
const LpSlugRoute = LpSlugRouteImport.update({
            id: '/lp/$slug',path: '/lp/$slug',getParentRoute: () => rootRouteImport
          })
const LegalTermsRoute = LegalTermsRouteImport.update({
            id: '/legal/terms',path: '/legal/terms',getParentRoute: () => rootRouteImport
          })
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
            id: '/legal/privacy',path: '/legal/privacy',getParentRoute: () => rootRouteImport
          })
const LegalCookiesRoute = LegalCookiesRouteImport.update({
            id: '/legal/cookies',path: '/legal/cookies',getParentRoute: () => rootRouteImport
          })
const LegalAccessibilityRoute = LegalAccessibilityRouteImport.update({
            id: '/legal/accessibility',path: '/legal/accessibility',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,SlugRoute: SlugRoute,AboutRoute: AboutRoute,AdminRoute: AdminRoute,AmazonRoute: AmazonRoute,AuthRoute: AuthRoute,BlogRoute: BlogRouteWithChildren,BundlesRoute: BundlesRoute,CartRoute: CartRoute,ContactRoute: ContactRoute,EventsRoute: EventsRoute,FaqRoute: FaqRoute,GiftsRoute: GiftsRoute,HowItWorksRoute: HowItWorksRoute,MiniGolfRoute: MiniGolfRoute,NightGolfRoute: NightGolfRoute,ResetPasswordRoute: ResetPasswordRoute,ReviewsRoute: ReviewsRoute,ShippingReturnsRoute: ShippingReturnsRoute,ShopRoute: ShopRoute,CheckoutReturnRoute: CheckoutReturnRoute,LegalAccessibilityRoute: LegalAccessibilityRoute,LegalCookiesRoute: LegalCookiesRoute,LegalPrivacyRoute: LegalPrivacyRoute,LegalTermsRoute: LegalTermsRoute,LpSlugRoute: LpSlugRoute,ProductsSlugRoute: ProductsSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)